import { render, staticRenderFns } from "./AppTechnologySwiper.vue?vue&type=template&id=2d5471b8&scoped=true&"
import script from "./AppTechnologySwiper.vue?vue&type=script&lang=js&"
export * from "./AppTechnologySwiper.vue?vue&type=script&lang=js&"
import style0 from "./AppTechnologySwiper.vue?vue&type=style&index=0&id=2d5471b8&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5471b8",
  null
  
)

export default component.exports